import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProvinceDropdownComponent } from './province-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [ProvinceDropdownComponent],
  exports: [ProvinceDropdownComponent]
})
export class ProvinceDropdownModule { }
